export default __webpack_public_path__ + "static/media/ic_belize.7ff01823.svg";